import { render } from "./WavetoApp.vue?vue&type=template&id=8afc659c&scoped=true"
import script from "./WavetoApp.vue?vue&type=script&lang=js"
export * from "./WavetoApp.vue?vue&type=script&lang=js"

import "./WavetoApp.vue?vue&type=style&index=0&id=8afc659c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afc659c"]])

export default __exports__